<i18n>
{
  "fr": {
    "departure": "Départ le",
    "return": "Retour le",
    "required": "Champs requis"
  },
  "en": {
    "departure": "Departure on",
    "return": "Return on",
    "required": "Required"
  }
}
</i18n>

<template>
  <v-row class="mt-3">
    <v-col
      cols="10"
      md="3"
      class="pt-0"
    >
      <label
        class="title-input"
        for="departLe"
      >
        {{ $t('departure') }}
      </label>
      <v-menu
        ref="outwardMenu"
        v-model="outwardMenu"
        :close-on-content-click="false"
        :return-value.sync="outwardDate"
        transition="scale-transition"
        offset-y
        max-width="290"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            id="departLe"
            v-model="outwardDateTmp"
            class="my-0 outward py-0"
            color="primary"
            background-color="primaryLight"
            placeholder="jj/mm/aaaa"
            append-icon="mdi-calendar"
            readonly
            solo
            flat
            required
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="outwardDate"
          :max="this.returnDate"
          :min="this.currentDate"
          no-title
          scrollable
          required
          :rules="[value => !!value || 'Champs requis']"
          @change="onDateOutwardSelected"
        />
      </v-menu>
      <span
        v-if="!outwardDate && this.formNotValidate"
        class="error-message"
      >
        {{ $t('required') }}
      </span>
    </v-col>
    <v-col
      cols="10"
      md="3"
      class="pt-0"
    >
      <label
        class="title-input"
        for="retourLe"
      >
        {{ $t('return') }}
      </label>
      <v-menu
        ref="returnMenu"
        v-model="returnMenu"
        :close-on-content-click="false"
        :return-value.sync="returnDate"
        transition="scale-transition"
        offset-y
        max-width="290"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            id="retourLe"
            v-model="returnDateTmp"
            class="my-0 outward py-0"
            color="primary"
            background-color="primaryLight"
            placeholder="jj/mm/aaaa"
            append-icon="mdi-calendar"
            readonly
            required
            solo
            flat
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="returnDate"
          :min="minReturnDate"
          no-title
          scrollable
          required
          :rules="[value => !!value || 'Champs requis']"
          @change="onDateReturnSelected"
        />
      </v-menu>
      <span
        v-if="!returnDate && this.formNotValidate"
        class="error-message"
      >
        {{ $t('required') }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment/moment'

export default {
  props: {
    formNotValidate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    outwardDate: '',
    outwardDateTmp: '',
    currentDate: new Date().toISOString().substr(0, 10),
    outwardMenu: false,
    returnDate: '',
    returnDateTmp: '',
    minReturnDate: new Date().toISOString().substr(0, 10),
    returnMenu: false
  }),
  watch: {
    outwardDateTmp () {
      if (this.outwardDateTmp === undefined) {
        this.outwardDate = ''
      }
    },
    returnDateTmp () {
      if (this.returnDateTmp === undefined) {
        this.returnDate = ''
      }
    }
  },
  methods: {
    formatDate (date) {
      if (date === '') {
        return null
      } else {
        const formatDate = moment(date, 'YYYY-MM-DD')

        if (this.$i18n.locale === 'fr') {
          formatDate.locale('fr')
          return formatDate.format('ddd D/MM/YYYY')
        } else if (this.$i18n.locale === 'en') {
          formatDate.locale('en')
          return formatDate.format('ddd DD/MM/YYYY')
        }
      }
    },
    onDateOutwardSelected () {
      this.minReturnDate = this.outwardDate
      this.outwardDateTmp = this.formatDate(this.outwardDate)
      this.$refs.outwardMenu.save(this.outwardDate)
      this.outwardMenu = false
    },
    onDateReturnSelected () {
      this.returnDateTmp = this.formatDate(this.returnDate)
      this.$refs.returnMenu.save(this.returnDate)
      this.returnMenu = false
    },
    validateDateForm () {
      if (this.outwardDate !== '' && this.returnDate !== '') {
        return 1
      } else {
        return 0
      }
    }
  }
}
</script>

<style scoped>
.title-input {
  color: #006fb9;
  font-size: 18px;
  font-weight: 550;
  opacity: 0.8;
}

.error-message {
  position: absolute;
  color: red;
  transform: translateY(-25px);
  font-size: 14px;
  font-style: italic;
}

</style>
